import GTMModule from '../../modules/analytics/modules/GTMModule'

export const analyticTypes = {
  gtm: GTMModule
}
